import '../elitePlansTheme.css'
import {
  ELITE_PLANS_ELITE_PRIME_TAB_ID,
  ELITE_PLANS_ELITE_TAB_ID,
  ElitePlansLandingProvider,
  useElitePlansLanding
} from '../ElitePlansLandingContext'
import { ElitePlansAnalyticsScreen } from '../constants/analyticsEvents'
import { ElitePlansTabbedPageLayout } from '../components/ElitePlansTabbedPageLayout'
import { ElitePlansSellBody } from '../components/ElitePlansSellBody'
import { ElitePlansStatusErrorScreen } from '../components/ElitePlansStatusErrorScreen'
import { useElitePlansStatus } from '../hooks/useElitePlansStatus'
import { useTrackElitePlansScreenLoadWhenReady } from '../hooks/useTrackElitePlansScreenLoadWhenReady'

export default function ElitePlansLandingPage() {
  return (
    <ElitePlansLandingProvider analyticsScreen={ElitePlansAnalyticsScreen.Landing}>
      <ElitePlansLandingPageContent />
    </ElitePlansLandingProvider>
  )
}

function ElitePlansLandingPageContent() {
  const { activeTab } = useElitePlansLanding()
  // Both tabs' status fetched up front (same query keys as the provider, so tab switches hit cache)
  const eliteStatus = useElitePlansStatus(ELITE_PLANS_ELITE_TAB_ID)
  const elitePrimeStatus = useElitePlansStatus(ELITE_PLANS_ELITE_PRIME_TAB_ID)

  useTrackElitePlansScreenLoadWhenReady(!eliteStatus.isLoading && !elitePrimeStatus.isLoading)

  // Either /advisory/status or /advisory/prime-status failed — error screen regardless of active tab
  if (eliteStatus.isError || elitePrimeStatus.isError) {
    return (
      <ElitePlansStatusErrorScreen
        themeId={activeTab.themeId}
        onRetry={() => {
          if (eliteStatus.isError) void eliteStatus.refetch()
          if (elitePrimeStatus.isError) void elitePrimeStatus.refetch()
        }}
      />
    )
  }

  return (
    <ElitePlansTabbedPageLayout>
      <ElitePlansSellBody />
    </ElitePlansTabbedPageLayout>
  )
}
